import React, { Suspense } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsAuthenticated } from "./store";
import Lottie from "react-lottie";
import lodder from "./components/lotties/lodder.json";

const Navbar = React.lazy(() => import("./components/Navbar/Navbar"));
const Priceing = React.lazy(() => import("./pages/priceing/Priceing"));
const Blog = React.lazy(() => import("./pages/blog/Blog"));
const BlogDetails = React.lazy(() => import("./pages/blog/BlogDetails"));
const ContactUs = React.lazy(() => import("./pages/contactUs/ContactUs"));
const Layout = React.lazy(() => import("./components/dashboardLayout/Layout"));
const Resource = React.lazy(() => import("./pages/resource/Resource"));
const DashBoardHome = React.lazy(() =>
  import("./components/dashboardLayout/DashBoardHome")
);
const SubjectScreen = React.lazy(() =>
  import("./pages/subjectScreen/SubjectScreen")
);
const StudyScreen = React.lazy(() => import("./pages/studyScreen/StudyScreen"));
const ReviewCards = React.lazy(() => import("./pages/reviewCards/ReviewCards"));
const CardOverview = React.lazy(() =>
  import("./pages/cardOverview/CardOverview")
);
const BookmarkOverview = React.lazy(() =>
  import("./pages/bookMark/BookmarkOverview")
);
const BookmarkCards = React.lazy(() =>
  import("./pages/bookMark/BookmarkCards")
);

const TopicScreen = React.lazy(() => import("./pages/topicScreen/TopicScreen"));

function App() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.isAuthenticated);

  const lodderOptions = {
    loop: true,
    autoplay: true,
    animationData: lodder, // Fire animation data
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    const authStatus = localStorage.getItem("isAuthenticated") === true;
    dispatch(setIsAuthenticated(authStatus));
  }, [isAuthenticated]);

  return (
    <Router>
      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center mt-5">
            <Lottie options={lodderOptions} height={400} width={400} />
          </div>
        }
      >
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Navbar />}></Route>

          <Route path="/dashboard" element={<Layout />}>
            {/* <Route index element={<Resource />} /> */}
            {/* <Route index path="resource" element={<Resource />} /> */}
            <Route path="contactUs" element={<ContactUs />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogDetails />} />
            <Route path="subjectScreen" element={<SubjectScreen />} />
            <Route path="studyScreen" element={<StudyScreen />} />
            <Route path="reviewCards" element={<ReviewCards />} />
            <Route path="cardOverview" element={<CardOverview />} />
            <Route path="bookmarkOverview" element={<BookmarkOverview />} />
            <Route path="subjectScreen/:sub" element={<TopicScreen />} />
            <Route path="bookmarks" element={<BookmarkCards />} />
            <Route path="price" element={<Priceing />} />
          </Route>

          {/* Home Route (if needed outside the dashboard structure) */}
          <Route path="/home" element={<DashBoardHome />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
